import React from "react"
import { Link } from "gatsby"
import styled from "@emotion/styled"

const Nav = styled.nav`
  display: flex;
  flex-direction: column;
  padding-bottom: 3rem;

  @media (min-width: 768px) {
    padding: 0;
    flex-direction: row;
  }

  @media (max-width: 768px) {
    flex-direction: row;
    padding: 0;
    justify-content: space-between;
    margin-left: 8%;
    margin-right: 8%;
  }
`

const NavLink = styled(Link)`
  color: #fff;
  font-weight: 700;
  font-family: "Lato", sans-serif;
  text-decoration: none;
  padding: 0.5rem;
  margin-right: 1rem;
  
  &.current-page {
    border-bottom: 2px solid #fff;
  }
`

const Navigate = () => {
  return (
    <Nav>
      <NavLink to={"#home"} activeClassName="current-page">
        Inicio
      </NavLink>
      <NavLink to={"#servicios"} activeClassName="current-page">
        Servicios
      </NavLink>
      <NavLink to={"#quienes-somos"} activeClassName="current-page">
        Quienes Somos
      </NavLink>
      <NavLink to={"#contacto"} activeClassName="current-page">
        Contacto
      </NavLink>
    </Nav>
  )
}

export default Navigate
